import React, { Component } from 'react';
import config from '../Config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouzz, faInstagramSquare,  faFacebookF, faPinterestP } from '@fortawesome/free-brands-svg-icons';

class Contact extends Component {

	componentDidMount() {
        document.title = `${config.name} ・ Contatti`;
    }

    render() {

        const icons = [
            { icon: faFacebookF, url: config.facebook_url, action: "", title: config.facebook_account_name},
            { icon: faInstagramSquare, url: config.instagram_url, action: "", title: config.instagram_account_name},
            { icon: faHouzz, url: config.houzz_url, action: "", title: config.houzz_account_name},
            { icon: faPinterestP, url: config.pinterest_url, action: "", title: config.pinterest_account_name}
        ];

        return (
            <div className='b-light'>
                <div className='content-wrapper m-c p-tb-10'>
                    <div className='c-100'>
                        <h1 className='madegra animated-item fade-in-slide-up'>{config.name}</h1>
                        <h4 className='ervasera m-t-2 animated-item fade-in-slide-up delay-1'>
                            Dai vita alla tua idea: scrivimi per iniziare.
                        </h4>
                        <ul className='m-t-5 animated-item fade-in-slide-up delay-2'>
                            <li className='c-40 d-i-b v-a-t sm-c-100 sm-m-b-2'>
                                <ul className='m-b-2'>
                                    <h6 className='sans-serif uppercase '>
                                        E-Mail
                                    </h6>
                                    <p>
                                        <a href={`mailto:${config.email}`}>{config.email}</a>
                                    </p>
                                </ul>
                            </li>
                            <li className='c-30 d-i-b v-a-t sm-c-100 sm-m-b-2'>
                                <ul className='m-b-1'>
                                    <h6 className='sans-serif uppercase'>
                                        Telefono
                                    </h6>
                                    <p><a href={`tel:${config.phone_plain}`}>{config.phone}</a></p>
                                </ul>
                            </li>
                            <li className='c-30 d-i-b v-a-t sm-c-100'>
                                <ul className='m-b-2'>
                                    <h6 className='sans-serif uppercase '>
                                        Social
                                    </h6>
                                    <p>
                                        {icons.map((item, index) => (
                                            <a target="_blank" className='d-i-b' href={item.action + item.url}>
                                                <FontAwesomeIcon key={index} icon={item.icon} className='p-r-2'/>
                                            </a>
                                        ))}
                                    </p>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>  
            </div>      
        );
    }
}

export default Contact
